module.exports = __webpack_public_path__ + "static/fabric-image-fit-center-cover-50cd48617b7ad91af37cc95649645372.png";